// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2hVzR","detailsBorder":"styles_detailsBorder__3KVnE"};